<svg
  xmlns="http://www.w3.org/2000/svg"
  id="svg-source"
  style="position: fixed; width: 0; height: 0"
>
  <symbol id="i2g-note-success-icon" viewBox="0 0 16 16">
    <g id="Messaging" stroke="none" stroke-width="1" fill="none">
      <g
        id="Messaging-/-x_overrides-/-Status-Success"
        transform="translate(-8.000000, -24.000000)"
      >
        <g
          id="icon/Message/Success16"
          transform="translate(8.000000, 24.000000)"
        >
          <rect id="bounding-box" x="0" y="0" width="16" height="16"></rect>
          <g id="iconSuccess">
            <path
              d="M8,16 C12.418278,16 16,12.418278 16,8 C16,3.581722 12.418278,0 8,0 C3.581722,0 0,3.581722 0,8 C0,12.418278 3.581722,16 8,16 Z"
              id="Background"
              fill="#22A971"
            ></path>
            <polygon
              id="Combined-Shape"
              fill="#FFFFFF"
              points="6.2010256 9.8382602 10.9282516 3.78768687 12.2170334 4.78539998 6.35597141 12.2778604 6.35288112 12.2716116 6.35352188 12.2927621 3.2 9.14373677 4.32429297 7.96152756"
            ></polygon>
          </g>
        </g>
      </g>
    </g>
  </symbol>

  <symbol id="i2g-note-info-icon" viewBox="0 0 16 16">
    <g
      id="Messaging"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="Messaging-/-x_overrides-/-Status-Information"
        transform="translate(-8.000000, -24.000000)"
      >
        <g id="icon/Message/Info16" transform="translate(8.000000, 24.000000)">
          <rect id="bounding-box" x="0" y="0" width="16" height="16"></rect>
          <g id="iconInformation">
            <circle id="Background" fill="#0875E2" cx="8" cy="8" r="8"></circle>
            <rect
              id="stroke"
              fill="#FFFFFF"
              x="7"
              y="7"
              width="2"
              height="6"
            ></rect>
            <rect
              id="Dot"
              fill="#FFFFFF"
              x="7"
              y="3"
              width="2"
              height="2"
            ></rect>
          </g>
        </g>
      </g>
    </g>
  </symbol>

  <symbol id="i2g-note-alert-icon" viewBox="0 0 16 16">
    <g
      id="icon/Message/Alert16"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <rect id="bounding-box" x="0" y="0" width="16" height="16"></rect>
      <g id="iconAlert">
        <circle id="Background" fill="#E80E51" cx="8" cy="8" r="8"></circle>
        <rect
          id="Stroke"
          fill="#FFFFFF"
          x="7"
          y="3"
          width="2"
          height="6"
        ></rect>
        <polygon id="Dot" fill="#FFFFFF" points="7 11 9 11 9 13 7 13"></polygon>
      </g>
    </g>
  </symbol>
</svg>

<div class="content-wrapper">
  <i2g-icon [icon]="leftIcon"> </i2g-icon>

  <p class="message">
    {{ message }}
  </p>
</div>
